import Label from "lib/Label";
import "./index.scss";
import { useSelector,useDispatch } from "react-redux";
import { Multiselect } from "multiselect-react-dropdown";
import { useEffect, useState } from "react";
import { getCountriesCode } from "api/formDisplay";
import { setLoadingState } from "redux/staticData";
const MultiDropdown = (props) => {
  const {
    options,
    options_type,
    label,
    web_grid_col,
    mobile_grid_col,
    onChange,
    placeholder,
    name,
    value: userValue,
    class_name,
    togglecopy,
    togglesublable,
    error,
    copyToClipboard,
    selectedData,
    setSelectedData,
    size,
    validators,
  } = props;
  const dispatch = useDispatch();
  const countryData = useSelector(
    (state) => state.staticData?.countryData
  );
  const status = useSelector(
    (state) => state.staticData?.status
  ); 
  const [option, setOption] = useState([]);
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const isToggled = useSelector((state) => state.formData.isToggled);
  useEffect(() => {
    if (options_type) {
      if(countryData?.length == 0 && status == false){
        dispatch(getCountriesCode())
     }
      mapOptions()
    } else {
      setOption(options);
    }
  }, []);
  const mapOptions = () => {
    let options = [];
    if (options_type == "globalCountries") {
      for (let i in countryData) {
        if ("country_name" in countryData[i]) {
        let paramObj = {};
        paramObj.label = countryData[i].country_name;
        paramObj.value = countryData[i].country_name;
        options.push(paramObj);
        }
      }
    } else if (options_type == "globalNationality") {
      for (let i in countryData) {
        let paramObj = {};
        if ("nationality" in countryData[i]) {
          paramObj.label = countryData[i].nationality;
          paramObj.value = countryData[i].nationality;
          options.push(paramObj);
        }
      }
    }
    setOption(options);
  };
  let dropdowndata;
  const onhandelAdd = (selectedList, selectedItem) => {
    dropdowndata = [];
    selectedList.forEach((element) => {
      dropdowndata.push(element);
    });
    onChange(name, dropdowndata);
  };

  const onhandelRemove = (selectedList, selectedItem) => {
    dropdowndata = [];
    selectedList.forEach((element) => {
      dropdowndata.push(element);
    });
    onChange(name, dropdowndata);
  };

  return (
    <div className={class_name + " " + size}>
      <Label
        label={label}
        togglecopy={togglecopy}
        togglesublabel={togglesublable}
        copyToClipboard={copyToClipboard}
        selectedData={selectedData}
        setSelectedData={setSelectedData}
        validators={validators}
      />
      <Multiselect
        customCloseIcon={
          <div className="mt-1 px-1">
            <i class="fa-sharp fa-solid fa-xmark"></i>
          </div>
        }
        style={{
          chips: {
            background: "#F0EFEF 0% 0% no-repeat padding-box",
            color: "black",
            border: "1px solid #8097ac",
            borderRadius: "0px",
            height: "36px",
            paddintTop: "3px",
            fontWeight: "900",
          },
          multiselectContainer: {
          },
          searchBox: {
            border: "1px solid #0c0d0e",
            borderRadius: "0px",
          },
        }}
        className={`multi_dropdown_container ${errorClass}`}
        value={userValue?.label ||(selectedData && selectedData[name])}
        selectedValues={userValue?.label ||( selectedData &&selectedData[name])}
        onSelect={onhandelAdd}
        onRemove={onhandelRemove}
        name={name}
        options={option}
        displayValue="label"
        id={name}
        placeholder={placeholder}
        disabled={isToggled && userValue?.label && userValue?.label?.length}
        showArrow={true}
      ></Multiselect>
    </div>
  );
};

export default MultiDropdown;
